const translation = {
  Product: "제품",
  "Header.productNav": "LUKKEY 제품",
  Feature: "특징",
  "About Us": "우리에 대해",
  FAQ: "자주 묻는 질문",
  "Privacy Policy": "개인정보 처리방침",
  "Help Center": "고객센터",
  "Header.infoMenu": "더보기",
  "Header.appNow": "앱 받기",
  "Header.appModal.title": "지금 LUKKEY 앱을 사용하세요",
  "Header.appModal.subtitle": "플랫폼을 선택해 LUKKEY 공식 모바일 앱을 받으세요.",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "iPhone에 공식 앱을 설치하세요.",
  "Header.appModal.iosButton": "열기",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "Google Play에서 공식 Android 앱을 받으세요.",
  "Header.appModal.googlePlayButton": "열기",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "최신 공식 APK를 직접 다운로드하세요.",
  "Header.appModal.androidButton": "다운로드",
  "Header.appModal.note": "공식 모바일 다운로드만 제공됩니다. 최신 버전은 위 링크를 이용하세요.",
  "Academy": "아카데미",
  "Legal": "법률",
  "AboutUs.title": "LUKKEY 소개",
  "AboutUs.lede": "LUKKEY는 디지털 자산 소유권을 위한 최고 수준의 보안을 구축하는 데 전념하는 스위스 하드웨어 월렛 브랜드입니다.",
  "AboutUs.vision.closing": "당신의 키. 당신의 자산. 당신의 미래.",
  "AboutUs.quote": "LUKKEY는 사람과 디지털 자산 사이에 보안 레이어를 구축합니다.",
  "AboutUs.block1": "LUKKEY는 스위스를 기반으로 합니다. 안전한 셀프 커스터디를 위한 하드웨어 월렛에 집중합니다.",
  "AboutUs.block2": "제품은 보안 요소, 위변조 방지 보호, 완전한 오프라인 아키텍처를 결합합니다. 목표는 개인 키를 격리된 환경에 유지하는 것입니다.",
  "AboutUs.block3": "시스템은 Wi‑Fi, USB 또는 직접적인 네트워크 의존 없이 설계되었습니다. 지문 접근, NFC 백업 도구, 폭넓은 자산 지원으로 일상 사용에서도 실용성을 유지합니다.",
  "AboutUs.block5": "LUKKEY는 핵심 펌웨어와 소프트웨어에 대해 개방적이고 감사 가능한 접근 방식을 따릅니다. 보안에 대한 주장은 점검 가능하고 검증 가능해야 합니다.",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "지원 요청",
  "WarrantySupport.intro":
    "지원 요청을 제출하려면 아래 정보를 입력하세요.",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "문제 요약",
  "WarrantySupport.form.issueTitle.placeholder": "간단한 요약을 입력하세요",
  "WarrantySupport.form.warrantyType.label": "요청 유형",
  "WarrantySupport.form.warrantyType.placeholder": "요청 유형 선택",
  "WarrantySupport.form.warrantyType.product": "기기 문제",
  "WarrantySupport.form.warrantyType.service": "앱/계정 문제",
  "WarrantySupport.form.warrantyType.replacement": "기타",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "문제 또는 요청을 자세히 작성하세요",
  "WarrantySupport.form.submit": "지원 요청 제출",
  "WarrantySupport.alert.success": "지원 요청이 제출되었습니다!",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "고객센터",
  "HelpCenter.intro":
    "LUKKEY 도움말 센터에 오신 것을 환영합니다! 암호화폐가 처음이거나 콜드 월렛에 도움이 필요하다면 올바른 곳에 오셨습니다. 우리의 콜드 월렛 솔루션은 디지털 자산을 가장 안전하게 보관하고 관리하는 방법을 제공합니다. 아래에서 자주 묻는 질문과 문제 해결 팁을 확인하세요.",
  "HelpCenter.section4.title": "추가 도움이 필요하신가요?",
  "HelpCenter.section4.intro": "온라인으로 지원 요청을 시작하면 시간을 절약할 수 있으며 전문가와 연결해 드립니다. 보안을 위해 공식 지원은 복구 문구나 개인 키를 절대 요청하지 않습니다:",
  "HelpCenter.contact.hint": "버튼을 눌러 지원 요청을 보내면 이메일로 안내드리겠습니다.",
  "HelpCenter.cta.warranty": "지원 요청 보내기",
  brandName: "LUKKEY",
  tagline: "이전에 없던 방식으로 암호화폐를 관리하세요",
  description:
    "우리의 앱을 통해 재정적 자유의 여정을 시작하세요. 고급 냉지갑 기술로 자산을 보호하고 더 스마트하고 효과적으로 재정을 관리하세요. 당신의 재정 건강은 우리의 최우선입니다.",
  "home.seoTitle": "LUKKEY | 안전한 셀프 커스터디를 위한 스위스 하드웨어 월렛",
  "home.seoDescription": "LUKKEY는 콜드 월렛 보안, 개인 키 오프라인 보호, 지문 접근, NFC 백업에 집중한 스위스 하드웨어 월렛 브랜드로, 더 안전한 셀프 커스터디를 지원합니다.",
  learnMore: "자세히 보기",
  "Lock Your Crypto, Securely": "암호화폐를 안전하게 잠그세요",
  Testimonials: "고객 리뷰",
  Testimonial1:
    "몇 달 동안 이 콜드 월렛을 사용해왔으며, 그 신뢰성과 보안 기능에 깊은 인상을 받았습니다. 강력히 추천합니다!",
  Testimonial2:
    "이 콜드 월렛은 제 기대를 뛰어넘었습니다! 사용자 친화적인 인터페이스와 최고 수준의 보안 덕분에 암호화폐에 진지한 사람이라면 누구나 필수적으로 가져야 할 도구입니다.",
  Testimonial3:
    "이전에 여러 콜드 월렛을 사용해봤지만, 이 제품은 두각을 나타냅니다. 세련된 디자인과 고급 기능 덕분에 제 암호 자산 관리가 훨씬 쉬워졌습니다.",
  "John Doe": "존 도",
  "Cryptocurrency Enthusiast": "암호화폐 애호가",
  "Jane Smith": "제인 스미스",
  "Crypto Security Advocate": "암호화폐 보안 옹호자",
  "Alex Johnson": "알렉스 존슨",
  "Investment Analyst": "투자 분석가",
  "Touchscreen Interface": "터치스크린 인터페이스",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "직관적인 터치스크린 인터페이스를 통해 암호화폐 관리가 쉬워집니다. 빠르고 간편한 디지털 자산 탐색을 통해 빠른 거래와 안전한 관리가 가능합니다.",
  "Bluetooth Connectivity": "블루투스 연결",
  "Wireless syncing with your devices for real-time updates.":
    "디바이스와 무선으로 동기화되어 실시간으로 업데이트됩니다.",
  "Airtag Tracking": "Airtag 추적",
  "Track your wallet easily with built-in Airtag.":
    "내장된 Airtag로 지갑을 쉽게 추적하세요.",
  "Secure Chip Technology": "보안 칩 기술",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "고급 보안 칩이 탑재되어 있어 귀하의 중요한 디지털 자산을 무단 접근과 사이버 위협으로부터 안전하게 보호합니다.",
  "Cross-Platform Support": "크로스 플랫폼 지원",
  "Works with various platforms for easy accessibility.":
    "여러 플랫폼에서 손쉽게 접근할 수 있습니다.",
  AboutUsDescription1:
    "LUKKEY에서는 암호화폐 자산을 안전하게 관리하는 고품질 솔루션을 제공합니다.",
  AboutUsDescription2:
    "본사는 스위스 추크에 있습니다. 경험이 풍부한 전문가 팀과 함께 디지털 통화 시장의 끊임없이 변화하는 환경에 혁신하고 적응하려고 노력하고 있습니다.",
  BlockchainNetworksSupported: "지원되는 블록체인 네트워크",
  CryptocurrenciesSupported: "6,000개 이상의 암호화폐 지원",
  Years: "년",
  ExpertiseInSecurity: "보안 전문 지식",
  FrequentlyAskedQuestions: "자주 묻는 질문",
  WhatIsColdWallet: "콜드 월렛이란 무엇인가요?",
  ColdWalletDescription:
    "콜드 월렛은 디지털 자산을 오프라인으로 저장하는 암호화폐 지갑의 일종으로, 해킹과 다른 온라인 위협에 덜 취약합니다. 인터넷에 연결되어 자주 거래하는 데 편리한 핫 월렛과 달리, 콜드 월렛은 장기 보관에 더 적합하며 보안성이 강화되어 있습니다.",
  HowToSetUpColdWallet: "콜드 월렛을 어떻게 설정하나요?",
  ColdWalletSetupDescription:
    "콜드 월렛을 설정하려면 일반적으로 보안된 오프라인 장치에서 장치를 초기화해야 합니다. 장치가 분실되거나 고장날 경우 자산에 접근할 수 있도록 복구 문구를 생성하고 안전하게 보관해야 합니다. 구매 시 제공되는 자세한 설명을 통해 설정 프로세스를 원활하게 진행할 수 있습니다。",
  CryptocurrenciesCompatibleWithColdWallet:
    "어떤 암호화폐가 콜드 월렛과 호환되나요?",
  CryptocurrenciesCompatibilityDescription:
    "저희 콜드 월렛은 비트코인, 이더리움, 라이트코인 등 주요 암호화폐를 비롯해 다양한 알트코인을 지원합니다. 지원되는 암호화폐의 전체 목록은 저희 웹사이트에서 확인하거나 제품 문서를 참조해 주세요。",
  HowToSecureColdWallet: "콜드 월렛을 어떻게 안전하게 보호하나요?",
  ColdWalletSecurityDescription:
    "콜드 월렛을 안전하게 보호하려면 복구 문구를 안전하고 비공개된 장소에 보관하고, 다른 사람과 공유하지 않으며, 생체 인식 잠금장치나 보안 케이스와 같은 추가 보안 조치를 고려하세요. 공식 웹사이트에서 월렛의 펌웨어를 정기적으로 업데이트하는 것도 보안을 강화하는 데 도움이 됩니다。",
  ColdWalletNotWorking:
    "콜드 월렛이 작동하지 않거나 오류가 발생하면 어떻게 해야 하나요？",
  ColdWalletErrorDescription:
    "콜드 월렛에 문제가 발생하면 사용자 가이드의 문제 해결 섹션을 참조하세요. 특정 문제에 대해서는 웹사이트를 통해 지원팀에 문의하세요. 지원 프로세스를 신속하게 진행하려면 장치 정보를 준비하세요。",
  Community: "커뮤니티",
  "Join our community on your favorite platform to stay up-to-date, ask questions, and connect with other users.":
    "좋아하는 플랫폼에서 우리 커뮤니티에 가입하여 최신 정보를 받고, 질문을 하고, 다른 사용자와 연결하세요。",
  "Subscribe.title": "제품 업데이트 받기",
  "Subscribe.subtitle":
    "암호화폐 트렌드는 저희가 대신 추적합니다. 제품 업데이트, 시장 인사이트, 독점 혜택을 — 받은편지함으로 바로 받아보세요.",
  "Subscribe.placeholder": "이메일 주소 입력",
  "Subscribe.button": "제품 업데이트 구독",
  "Subscribe.input.aria": "이메일 주소 입력란",
  "Subscribe.success": "구독해 주셔서 감사합니다. 확인 이메일을 발송했습니다.",
  "Subscribe.error": "구독에 실패했습니다. 잠시 후 다시 시도해 주세요.",
  "Subscribe.invalid": "유효한 이메일 주소를 입력해 주세요.",
  "Subscribe.privacy":
    "이메일 주소는 뉴스레터 및 업데이트 전송에만 사용됩니다. 이메일의 링크를 통해 언제든지 구독을 취소할 수 있습니다.",
  "Subscribe.learnMore": "데이터 관리 및 권리에 대해 자세히 알아보기.",
  "Subscribe.popupCompact.title": "업데이트 받기",
  "Subscribe.popupCompact.subtitle":
    "제품 업데이트와 보안 인사이트. 스팸은 보내지 않습니다.",
  "Subscribe.popupCompact.button": "구독",
  "Subscribe.popupCompact.privacy":
    "이메일 전용. 언제든지 구독 해지할 수 있습니다.",
  "SubscribeConfirmed.alt.success": "구독 확인 완료",
  "SubscribeConfirmed.alt.failed": "구독 실패",
  "SubscribeConfirmed.title.success": "구독 확인 완료",
  "SubscribeConfirmed.title.failed": "구독 실패",
  "SubscribeConfirmed.message.success":
    "이메일을 확인해 주셔서 감사합니다. 구독이 활성화되었습니다. 환영 메일을 받은편지함으로 발송했습니다.",
  "SubscribeConfirmed.message.failed":
    "확인 링크가 유효하지 않거나 만료되었습니다. 홈페이지로 돌아가 구독을 다시 시도해 주세요.",
  "SubscribeConfirmed.cta.backHome": "홈으로 돌아가기",
  "SubscribeConfirmed.note.unsubscribe":
    "이메일 내 링크를 통해 언제든지 구독을 취소할 수 있습니다.",
  // ===== MarketView i18n =====
  "MarketView.title": "마켓 대시보드",
  "MarketView.loading": "로딩 중...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (Twitter)",
  "MarketView.tabError.failed": "이 탭을 렌더링하지 못했습니다",
  "MarketView.unknownError": "알 수 없는 오류",

  // ===== Common i18n =====
  "Common.refresh": "새로고침",
  "Common.toggleSeriesVisibility": "이 시리즈 표시/숨기기",
  "Common.error": "오류",
  "Common.dataUpdateTime": "데이터 업데이트 시간",
  "Common.loading": "로딩 중...",
  "Common.noDataSource": "데이터 없음(데이터 소스 미제공)",

  // ===== Common ranges =====
  "Common.to": "~",
  "Common.clear": "지우기",
  "Common.range.thisMonth": "이번 달",
  "Common.range.lastMonth": "지난 달",
  "Common.range.last2": "최근 2개월",
  "Common.range.last3": "최근 3개월",
  "Common.range.last6": "최근 6개월",
  "Common.range.thisYear": "올해",
  "Common.range.all": "전체",
  "Common.range.custom": "사용자 지정",
  "Common.showFilters": "필터 표시",
  "Common.hideFilters": "필터 숨기기",
  "Common.search": "검색",
  "Common.priority": "우선순위",
  "Common.owner": "담당자",
  "Common.collaborator": "협업자",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "백엔드 data/youtube_stats.json 다운로드",
  "YouTubeTab.downloadJson": "youtube_stats.json 다운로드",
  "YouTubeTab.loading": "YouTube 지표 로딩 중...",
  "YouTubeTab.errorHint":
    "API 키가 설정되지 않은 경우 backend/.env 에 YOUTUBE_API_KEY 또는 GOOGLE_API_KEY 를 설정하고 백엔드를 재시작하세요.",
  "YouTubeTab.header.totalViews": "총 조회수(멀티 채널, 단위: 10k)",
  "YouTubeTab.header.totalSubscribers": "총 구독자(멀티 채널, 단위: 10k)",
  "YouTubeTab.dist.views": "조회수 분포(10k)",
  "YouTubeTab.dist.subscribers": "구독자 분포(10k)",
  "YouTubeTab.card.location": "소재지:",
  "YouTubeTab.card.registeredAt": "등록일:",
  "YouTubeTab.card.currentSubscribers": "현재 구독자",
  "YouTubeTab.card.currentVideos": "현재 동영상 수",
  "YouTubeTab.card.currentTotalViews": "현재 총 조회수",
  "YouTubeTab.card.currentTotalComments": "현재 총 댓글 수",
  "YouTubeTab.chart.totalSubscribers": "총 구독자",
  "YouTubeTab.chart.totalViews": "총 조회수",
  "YouTubeTab.chart.totalComments": "총 댓글 수",
  "YouTubeTab.chart.totalVideos": "총 동영상 수",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "백엔드 data/x_stats.json 다운로드",
  "XTab.downloadJson": "x_stats.json 다운로드",
  "XTab.loading": "X 지표 로딩 중...",
  "XTab.errorHint":
    "토큰이 설정되지 않은 경우 backend/.env 에 X_BEARER_TOKEN 또는 TWITTER_BEARER_TOKEN 을 설정하고 백엔드를 재시작하세요.",
  "XTab.header.totalFollowers": "총 팔로워(멀티 채널, 단위: 10k)",
  "XTab.header.totalEngagement":
    "총 참여도(최근 5개: 좋아요 + 리트윗 + 답글 + 인용, 단위: 10k)",
  "XTab.dist.followers": "팔로워 분포(10k)",
  "XTab.dist.engagement":
    "참여도 분포(최근 5개: 좋아요 + 리트윗 + 답글 + 인용, 단위: 10k)",
  "XTab.card.currentFollowers": "현재 팔로워",
  "XTab.card.currentFollowing": "현재 팔로잉",
  "XTab.card.currentTweets": "현재 트윗 수",
  "XTab.card.recentLikes": "최근 좋아요(최근 5개)",
  "XTab.card.recentRetweets": "최근 리트윗(최근 5개)",
  "XTab.card.recentReplies": "최근 답글(최근 5개)",
  "XTab.card.recentQuotes": "최근 조회수(콘텐츠 레벨, 최근 5개)",
  "XTab.card.listed": "리스트 등재 수(채널 레벨)",
  "XTab.smallChart.followers": "팔로워",
  "XTab.smallChart.tweets": "트윗",
  "XTab.smallChart.likes": "최근 좋아요",
  "XTab.smallChart.retweets": "최근 리트윗",
  "XTab.smallChart.replies": "최근 답글",
  "XTab.smallChart.quotes": "최근 조회수(콘텐츠 레벨)",
  "XTab.smallChart.following": "팔로잉",
  "XTab.smallChart.listed": "리스트",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "생성 월로 필터:",
  "Analytics.metric.completionRate": "완료율",
  "Analytics.metric.teamVelocity": "팀 속도",
  "Analytics.metric.blockerRatio": "블로커 비율",
  "Analytics.metric.workloadBalance": "작업 부하 균형",
  "Analytics.charts.statusDistribution": "상태 분포",
  "Analytics.charts.statusByMonthPercent": "월별 상태(비율)",
  "Analytics.charts.priorityDistribution": "우선순위 분포",
  "Analytics.charts.priorityByMonthPercent": "월별 우선순위(비율)",
  "Analytics.charts.functionTypeDistribution": "기능 유형 분포",
  "Analytics.charts.functionTypeByMonthPercent": "월별 기능 유형(비율)",
  "Analytics.blocker.ownerPie": "블로킹 이슈 · 담당자 분포(도넛)",
  "Analytics.blocker.ownerByMonth": "블로킹 이슈 · 월별 담당자(%)",
  "Analytics.bug.ownerPie": "버그 이슈 · 담당자 분포(도넛)",
  "Analytics.bug.ownerByMonth": "버그 이슈 · 월별 담당자(%)",
  "Analytics.ownerWorkloadDistribution": "팀 작업량 분포",
  "Analytics.mode.priority": "우선순위 분포",
  "Analytics.mode.status": "상태 분포",
  "Analytics.mode.type": "유형 분포",
  "Analytics.blocker.attentionNeeded": "즉각적인 주의가 필요한 이슈",
  "Analytics.common.status": "상태",
  "Analytics.common.owner": "담당자",
  "Analytics.insights.sectionTitle": "프로젝트 인사이트 및 제안",
  "Analytics.insights.efficiency.title": "효율 개선 제안",
  "Analytics.insights.efficiency.completionRate":
    "• 현재 완료율은 {{rate}}% 입니다. 블로커에 주의하세요",
  "Analytics.insights.efficiency.avgVelocity":
    "• 팀 평균 속도는 {{velocity}} 건/인 입니다",
  "Analytics.insights.efficiency.workloadBalance":
    "• 작업 부하 균형은 {{balance}}% 입니다",
  "Analytics.insights.risk.title": "리스크 경고",
  "Analytics.insights.risk.blockerRatio": "• 블로커 비율 {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• P0 이슈 비율 {{ratio}}%",
  "Analytics.insights.risk.suggestion": "• 우선순위가 높은 이슈부터 처리하세요",

  // ===== Kanban i18n =====
  "Kanban.title": "칸반 보기",
  "Kanban.totalIssues": "총 {{count}}개 이슈",
  "Kanban.searchPlaceholder": "제목, 이슈 번호, 담당자 또는 협업자 검색...",
  "Kanban.status.backlog": "백로그",
  "Kanban.status.inProgress": "진행 중",
  "Kanban.status.blocked": "차단됨 / 확인 대기",
  "Kanban.status.reviewTest": "리뷰 / 테스트",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "이슈 목록",
  "List.totalIssues": "총 {{count}}개 이슈",
  "List.viewDetails": "자세히 보기",
  "List.openInNewWindow": "새 창에서 열기",
  "List.empty.title": "이슈 없음",
  "List.empty.subtitle": "첫 번째 이슈를 만들어 워크플로를 시작하세요",

  // ===== Assets Register i18n =====
  "Assets.title": "자산 등록부",
  "Assets.totalSets": "총 세트",
  "Assets.table.employee": "직원",
  "Assets.table.setCount": "세트",
  "Assets.table.model": "모델",
  "Assets.total": "합계",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "프로젝트 이슈 추적",
  "LukkeyIssues.goToDemo": "데모 페이지로 이동",
  "LukkeyIssues.githubProject": "GitHub 프로젝트 ↗",
  "LukkeyIssues.githubManageIssues": "GitHub에서 직접 Issues 관리 ↗",
  "LukkeyIssues.financeModel": "파이낸스 모델",
  "LukkeyIssues.productCoreIssues": "제품 핵심 이슈",
  "LukkeyIssues.stats.totalIssues": "📊 총 이슈",
  "LukkeyIssues.stats.completed": "✅ 완료",
  "LukkeyIssues.stats.inProgress": "🔄 진행 중",
  "LukkeyIssues.stats.pending": "⏳ 대기",
  "LukkeyIssues.stats.blocked": "🚫 차단됨",
  "LukkeyIssues.stats.docs": "📚 문서 Docs",
  "LukkeyIssues.tabs.kanban": "칸반 보기",
  "LukkeyIssues.tabs.analytics": "애널리틱스",
  "LukkeyIssues.tabs.market": "마켓 대시보드",
  "LukkeyIssues.tabs.assets": "자산 등록부",
  "LukkeyIssues.shareToChatGPT": "ChatGPT로 LUKKEY.json 열기", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "LUKKEY 개인정보 처리방침",
  "PrivacyPolicy.intro.p1":
    "LUKKEY는 가장 안전한 프라이버시는 언제나 사용자 스스로의 손에 있는 것이라고 믿습니다.",
  "PrivacyPolicy.intro.p2":
    "따라서 LUKKEY 하드웨어 콜드월렛 또는 LUKKEY 모바일 애플리케이션(App)을 사용하더라도, 당사는 변함없는 원칙을 엄격히 준수합니다:",
  "PrivacyPolicy.intro.p3_strong":
    "사용자가 명시적으로 허용하지 않는 한, 당사는 어떠한 사용자 정보도 수집·저장·업로드하지 않습니다.",
  "PrivacyPolicy.intro.p3_tail":
    "사용과 관련된 모든 데이터는 사용자 기기에만 로컬로 저장되며, LUKKEY 또는 어떤 서버로도 전송되지 않습니다.",
  "PrivacyPolicy.intro.p4":
    "본 처리방침은 당사가 이 원칙을 어떻게 준수하는지 설명합니다.",

  "PrivacyPolicy.s1.title": "1. 적용 범위",
  "PrivacyPolicy.s1.appliesTo": "본 개인정보 처리방침은 다음에 적용됩니다:",
  "PrivacyPolicy.s1.item.hardware": "LUKKEY 하드웨어 콜드월렛",
  "PrivacyPolicy.s1.item.app": "LUKKEY 모바일 애플리케이션(App)",
  "PrivacyPolicy.s1.principle":
    "두 대상 모두 ‘제로 수집, 제로 업로드, 로컬 저장만’의 통합 프라이버시 원칙을 따릅니다.",

  "PrivacyPolicy.s2.title": "2. 당사가 수집하지 않는 정보",
  "PrivacyPolicy.s2.desc":
    "프라이버시 보호를 위해, 당사는 아래를 포함하되 이에 국한되지 않는 어떠한 사용자 정보도 수집·업로드·저장하지 않을 것을 명확히 약속합니다:",
  "PrivacyPolicy.s2.li.identity":
    "신원 정보: 이름, 전화번호, 이메일 주소, 우편 주소",
  "PrivacyPolicy.s2.li.walletSensitive":
    "월렛 민감 정보: 개인키, 니모닉(복구 구문), keystore 파일, 월렛 비밀번호",
  "PrivacyPolicy.s2.li.blockchain":
    "블록체인 데이터: 월렛 주소, 거래 내역, 자산 정보",
  "PrivacyPolicy.s2.li.behavior": "이용 행태: 앱 로그, 클릭 기록, 행동 분석",
  "PrivacyPolicy.s2.li.technical": "기술 정보: 기기 식별자, 위치 정보, IP 주소",
  "PrivacyPolicy.s2.inShort.title": "요약:",
  "PrivacyPolicy.s2.inShort.desc":
    "하드웨어 기기와 앱에서 보이는 모든 것은 오직 사용자 기기에만 존재합니다. LUKKEY는 이에 접근할 수 없습니다.",

  "PrivacyPolicy.s3.title": "3. 하드웨어 콜드월렛의 프라이버시 및 보안 설계",
  "PrivacyPolicy.s3.desc":
    "LUKKEY 콜드월렛은 완전 오프라인의 안전한 환경을 제공합니다. 주요 기능:",
  "PrivacyPolicy.s3.h1.title": "1. 군용 등급의 보안 하드웨어",
  "PrivacyPolicy.s3.h1.l1": "EAL6+ 인증 Secure Element",
  "PrivacyPolicy.s3.h1.l2": "하드웨어 레벨 전 구간 암호화 통신",
  "PrivacyPolicy.s3.h2.title": "2. 보안 기능",
  "PrivacyPolicy.s3.h2.l1": "지문 인증",
  "PrivacyPolicy.s3.h2.l2": "프라이버시 모드",
  "PrivacyPolicy.s3.h2.l3": "멀티 월렛 분리 관리",
  "PrivacyPolicy.s3.h3.title": "3. 완전한 격리",
  "PrivacyPolicy.s3.h3.l1": "인터넷 연결 없음",
  "PrivacyPolicy.s3.h3.l2": "데이터 케이블 연결 없음",
  "PrivacyPolicy.s3.h4.title": "4. 변조 방지 자가 파기",
  "PrivacyPolicy.s3.h4.desc":
    "기기가 분해·손상·비정상 침입을 당할 경우, Secure Element는 민감 데이터를 자동 파기하여 개인키 추출을 방지합니다.",
  "PrivacyPolicy.s3.h5.title": "5. 민감 작업은 Secure Element 내부에서만 수행",
  "PrivacyPolicy.s3.h5.l1": "월렛 생성",
  "PrivacyPolicy.s3.h5.l2": "월렛 가져오기(임포트)",
  "PrivacyPolicy.s3.h5.l3": "거래 서명",
  "PrivacyPolicy.s3.h5.note":
    "모든 민감 프로세스는 100% Secure Element 내부에서 이루어지며, 비보안 칩/저장소로 노출되지 않습니다.",
  "PrivacyPolicy.s3.h6.title": "6. Secure Element 외부에 민감 데이터 저장 금지",
  "PrivacyPolicy.s3.h6.desc":
    "기기의 비보안 저장 영역에는 개인키, 니모닉 등 어떠한 민감 정보도 저장되지 않습니다.",

  "PrivacyPolicy.s4.title": "4. LUKKEY App의 프라이버시 및 보안 설계",
  "PrivacyPolicy.s4.desc":
    "LUKKEY App은 정보 표시와 알림 제공에만 집중하며, 월렛의 민감 데이터를 처리하지 않습니다.",
  "PrivacyPolicy.s4.n1.title": "1. App이 하지 않는 것",
  "PrivacyPolicy.s4.n1.l1": "블록체인 월렛을 생성하지 않음",
  "PrivacyPolicy.s4.n1.l2": "블록체인 월렛을 가져오지 않음",
  "PrivacyPolicy.s4.n1.l3": "개인키 또는 니모닉을 저장하지 않음",
  "PrivacyPolicy.s4.n1.l4": "어떠한 사용자 데이터도 업로드하지 않음",
  "PrivacyPolicy.s4.n1.l5": "행동 분석·광고 추적·데이터 수집을 수행하지 않음",
  "PrivacyPolicy.s4.n2.title": "2. App이 하는 것",
  "PrivacyPolicy.s4.n2.l1": "하드웨어가 승인한 공개 접근 가능한 정보를 표시",
  "PrivacyPolicy.s4.n2.l2":
    "각 권한의 목적을 설명하는 프라이버시 설정 패널 제공",
  "PrivacyPolicy.s4.n2.l3": "사용자가 언제든 권한 활성/비활성을 완전 제어",
  "PrivacyPolicy.s4.n2.l4": "민감 정보 마스킹 제공",
  "PrivacyPolicy.s4.n2.l5": "특정 화면에서 스크린샷/녹화 비활성화",
  "PrivacyPolicy.s4.n2.l6": "로컬 매칭으로 의심스러운 블록체인 주소 탐지",
  "PrivacyPolicy.s4.n2.l7": "위험 URL·컨트랙트·주소 목록 정기 업데이트",
  "PrivacyPolicy.s4.n2.l8": "업데이트 흐름은 단방향(서버 → 기기)만",
  "PrivacyPolicy.s4.n2.l9": "업데이트 중 사용자 데이터는 절대 전송되지 않음",
  "PrivacyPolicy.s4.n3.title": "3. 로컬 저장",
  "PrivacyPolicy.s4.n3.p1":
    "App은 UI 환경설정, 언어, 테마 등 비민감 데이터만 로컬에 저장합니다. 이 데이터는:",
  "PrivacyPolicy.s4.n3.l1": "업로드되지 않음",
  "PrivacyPolicy.s4.n3.l2": "동기화되지 않음",
  "PrivacyPolicy.s4.n3.l3": "LUKKEY가 접근할 수 없음",

  "PrivacyPolicy.s5.title": "5. 데이터 전송 및 서버 정책",
  "PrivacyPolicy.s5.l1": "LUKKEY 서버는 어떠한 사용자 정보도 저장하지 않습니다",
  "PrivacyPolicy.s5.l2":
    "App–서버 통신은 데이터베이스/버전 업데이트에만 한정됩니다",
  "PrivacyPolicy.s5.l3": "통신 과정에서 사용자 정보는 전송되지 않습니다",
  "PrivacyPolicy.s5.l4":
    "설령 서버 침해가 발생하더라도, 애초에 해당 데이터를 취득하지 않으므로 노출될 사용자 데이터가 없습니다",

  "PrivacyPolicy.s6.title": "6. 오픈소스 투명성",
  "PrivacyPolicy.s6.l1": "LUKKEY App 소스코드는 오픈소스입니다",
  "PrivacyPolicy.s6.l2": "LUKKEY 하드웨어 임베디드 펌웨어도 오픈소스입니다",
  "PrivacyPolicy.s6.l3":
    "누구나 GitHub에서 감사할 수 있도록 전면 공개되어 있습니다",
  "PrivacyPolicy.s6.p": "투명성은 보안의 일부입니다.",

  "PrivacyPolicy.s7.title": "7. 사용자의 완전한 통제권",
  "PrivacyPolicy.s7.p":
    "당사가 사용자 정보를 수집하지 않더라도, 사용자는 자신의 기기를 완전히 통제할 수 있습니다:",
  "PrivacyPolicy.s7.l1": "언제든 App 권한을 비활성화할 수 있습니다",
  "PrivacyPolicy.s7.l2":
    "App을 삭제하여 모든 로컬 App 데이터를 제거할 수 있습니다",
  "PrivacyPolicy.s7.l3":
    "하드웨어 기기를 초기화하여 개인키와 월렛 데이터를 영구 삭제할 수 있습니다",
  "PrivacyPolicy.s7.p2":
    "LUKKEY는 이러한 조치에 개입하지 않으며, 개입할 수도 없습니다.",

  "PrivacyPolicy.s8.title": "8. 문의하기",
  "PrivacyPolicy.s8.p":
    "본 개인정보 처리방침과 관련한 문의는 아래로 연락해 주세요:",
  "PrivacyPolicy.s8.email": "이메일: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "주소: LUKKEY 본사, Baarerstrasse 25, 6300 Zug, Switzerland",
  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "확인 중...",
  "EmailOtp.title": "접근 제한: 이름과 이메일을 입력해 로그인 코드를 받으세요",
  "EmailOtp.nameLabel": "이름",
  "EmailOtp.namePlaceholder": "이름을 입력하세요",
  "EmailOtp.emailLabel": "이메일",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "코드 보내기",
  "EmailOtp.resendCode": "코드 다시 보내기",
  "EmailOtp.resendWithCountdown": "다시 보내기 ({{s}}s)",
  "EmailOtp.codeValidityHint": "인증 코드는 약 10분 동안 유효합니다",
  "EmailOtp.codeLabel": "이메일 인증 코드",
  "EmailOtp.codePlaceholder": "받은 인증 코드를 입력하세요",
  "EmailOtp.signIn": "로그인",
  "EmailOtp.message.codeSent": "인증 코드를 보냈습니다. 메일함을 확인하세요",
  "EmailOtp.error.nameRequired": "이름을 입력하세요",
  "EmailOtp.error.invalidEmail": "유효한 이메일 주소를 입력하세요",
  "EmailOtp.error.sendFailed":
    "인증 코드 전송에 실패했습니다. 잠시 후 다시 시도하세요.",
  "EmailOtp.error.codeRequired": "인증 코드를 입력하세요",
  "EmailOtp.error.verificationFailed": "인증에 실패했습니다",
  // ===== Academy i18n =====
  "Academy.hero.alert":
    "보안 안내: 링크를 항상 확인하고 복구 구문은 절대 공유하지 마세요.",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "아카데미",
  "Academy.hero.subtitle":
    "암호화폐 보안, 셀프 커스터디 및 LUKKEY 콜드월렛 사용에 대한 실용 가이드.",
  "Academy.search.placeholder": "튜토리얼, 모범 사례, FAQ 검색…",
  "Academy.search.hint": "[Enter]",
  "Academy.card.type.article": "기사",
  "Academy.list.title": "최신 가이드",
  "Academy.list.viewAll": "전체 보기",
  "Academy.list.empty": "결과가 없습니다. 다른 키워드를 시도하세요.",
  "Academy.image.placeholder": "이미지",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "아카데미로 돌아가기",
  "AcademyArticle.notFound": "기사를 찾을 수 없습니다",
  "AcademyArticle.author": "작성자",
  "AcademyArticle.unscheduled": "예약된 게시 시간이 없습니다",
  "home.hero.reserveCtaLabel": "얼리 액세스 — $1",
  "home.hero.reserveCtaNote": "전액 환불 가능합니다. 구매 약정은 필요 없습니다."
};
export default translation;
